import React from "react";

import { IActiveLearningLesson } from "../../../state";
import ActiveLearningProjectionSidebar from "../../../molecules/teacher/ActiveLearningProjectionSidebar";

import styles from "./ActiveLearningProjection.module.scss";

export interface Props {
  lesson: IActiveLearningLesson | null;
  prevLessonId: number | null;
  nextLessonId: number | null;
  onChangeLesson: (lessonId: number) => void;
}

const ActiveLearningProjection: React.FC<Props> = ({
  lesson,
  prevLessonId,
  nextLessonId,
  onChangeLesson,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.guidelineImages}>
        {lesson &&
          lesson.projection_image_urls?.map((url, i) => (
            <div className={styles.imageContainer} key={i}>
              <img
                className={styles.image}
                src={`https://admin.gear.enageed.net${url}`}
                alt={`guideline-${i}`}
              />
            </div>
          ))}
      </div>
      <ActiveLearningProjectionSidebar
        lesson={lesson}
        prevLessonId={prevLessonId}
        nextLessonId={nextLessonId}
        onChangeLesson={onChangeLesson}
      />
    </div>
  );
};

export default ActiveLearningProjection;
